import Cookies from 'js-cookie';
import { redirect } from 'next/navigation';

export async function publicFetch(
  url: string,
  fetchHeaders: RequestInit | undefined
) {
  const authToken = Cookies.get('adminUser');

  if (!authToken) return { ok: false, data: null, error: null };
  const headers = {
    ...fetchHeaders,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${JSON.parse(authToken || '')?.token ?? ''}`,
    },
  };

  try {
    const response = await fetch(url, authToken ? headers : {});
    if (response.status === 403) {
      redirect('/403');
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching data:', error);
    throw error; // or return null;
  }
}

export async function fetchBlob(url: string) {
  const authToken = Cookies.get('adminUser');

  if (!authToken) return { ok: false, data: null, error: null };
  const headers = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/octet-stream',
      Authorization: `Bearer ${JSON.parse(authToken || '')?.token ?? ''}`,
    },
  };

  try {
    const response = await fetch(url, authToken ? headers : {});

    if (response.status === 403) {
      redirect('/403');
    }
    const data = await response.blob();
    return data;
  } catch (error) {
    console.error('Error fetching data:', error);
    throw error; // or return null;
  }
}

export async function getDocumentContent(
  tenantId: string,
  companyId: string,
  documentId: string
) {
  return fetchBlob(
    `${process.env.NEXT_PUBLIC_API_URL}/tenants/${tenantId}/companies/${companyId}/documents/${documentId}/content`
  );
}

export async function getUniqueDocumentContent(
  tenantId: string,
  companyId: string,
  documentId: string,
  parentId: string
) {
  return fetchBlob(
    `${process.env.NEXT_PUBLIC_API_URL}/tenants/${tenantId}/companies/${companyId}/documents/unique-document-parent/${parentId}/document/${documentId}/content`
  );
}
